// Single source of truth for password rules.
// Update PASSWORD_MIN_LENGTH here and every component picks it up automatically.

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_PLACEHOLDER = `Min. ${PASSWORD_MIN_LENGTH} characters`;

export const PASSWORD_HELP_TEXT = `Min. ${PASSWORD_MIN_LENGTH} characters, not all the same character.`;

/**
 * Validate a password against the frontend rules.
 * Returns null if valid, otherwise a user-facing error string.
 */
export function validatePassword(value) {
  if (!value) {
    return 'Please enter a password.';
  }
  if (value.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  const allSame = value.split('').every((c) => c === value[0]);
  if (allSame) {
    return 'Password cannot be all the same character.';
  }
  return null;
}
